import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Welcome from "./pages/welcome";
import Documentation from "./pages/Documentation";
import MobileDevelopment from "./pages/MobileDevelopment";
import WebDevelopment from "./pages/WebDevelopment";
import ModelTraining from "./pages/ModelTraining";
import Contact from "./pages/Contact";
import { CreateFeedback } from "./pages/CreateFeedback";
import { FeedbackDisplay } from "./pages/FeedbackDisplay";
import { FeedbackSubmit } from "./pages/FeedbackSubmit";
import CustomerChat from "./pages/CustomerChat";
import AdminChat from "./pages/AdminChat";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/achat" element={<AdminChat />} />
        <Route path="/ChatWidget" element={<CustomerChat />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="/mobile-development" element={<MobileDevelopment />} />
        <Route path="/ai-ml-solutions" element={<ModelTraining />} />        
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/create-feedback" element={<CreateFeedback />} />
        <Route path="/submit-feedback/:projectName" element={<FeedbackSubmit/>} />
        <Route path="/feedbacks" element={<FeedbackDisplay />} />
      </Routes>
    </Router>
  );
}

export default App;
